import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalConfirmationModule} from '../../../shared/modals/modal-confirmation/modal-confirmation.module';
import {CModulesOverviewRoutingModule} from './cmodules-overview-routing.module';
import {CModulesOverviewComponent} from './cmodules-overview.component';
import {CModulesOverviewHttpRepository} from './repositories/cmodules-overview.repository.http';
import {CModulesOverviewService} from './services/cmodules-overview.service';

import {CModulesDetailsHttpRepository} from '../cmodules-details/repositories/cmodules-details.repository.http';
import {CModulesDetailsService} from '../cmodules-details/services/cmodules-details.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    CModulesOverviewRoutingModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    CModulesOverviewComponent,
  ],
  providers: [
    CModulesOverviewService,
    {
      provide: 'ICModulesOverviewRepository',
      useClass: CModulesOverviewHttpRepository,
    },
    CModulesDetailsService,
    {
      provide: 'ICModulesDetailsRepository',
      useClass: CModulesDetailsHttpRepository,
    },
  ],
})
export class CModulesOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-overview/cmodules-overview.module.ts